import { useFeatureFlags } from "@hooks/http";
import { useSelectedCycle } from "@pages/mmm/hooks/use-selected-cycle";

export const useShowReferencePeriod = () => {
  const { selectedCycle } = useSelectedCycle();
  const { hasFeatureFlag } = useFeatureFlags();
  const enableMmmReferencePeriod = hasFeatureFlag("enableMmmReferencePeriod");

  return (
    enableMmmReferencePeriod &&
    selectedCycle?.model?.run_result?.cycle_dataset_path
  );
};
